import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Handles /rss and /feed routes.
 *
 * SEO/AEO reality: many crawlers, feed readers, and AI ingest bots try /rss
 * or /feed by convention. Our SPA currently 200-serves the app shell there,
 * which is misleading. This component:
 *
 *   1. Emits a canonical + refresh meta pointing to the real feed so no-JS
 *      crawlers reach the RSS on next hop.
 *   2. Does a client-side redirect so real users land on the correct feed.
 *
 * /rss  -> our combined portfolio+substack feed at /api/rss.xml
 * /feed -> Rudhra's Substack RSS (editorial content only)
 */
export default function RssRedirect() {
  const { pathname } = useLocation();
  const target =
    pathname.replace(/\/$/, "") === "/feed"
      ? "https://rudhravishnu.substack.com/feed"
      : "https://relatable.studio/api/rss.xml";

  useEffect(() => {
    // Belt & suspenders: meta refresh below is fine, this covers modern browsers
    window.location.replace(target);
  }, [target]);

  return (
    <html lang="en">
      <head>
        <meta charSet="utf-8" />
        <meta httpEquiv="refresh" content={`0; url=${target}`} />
        <link rel="canonical" href={target} />
        <title>Relatable Studio — RSS Feed</title>
        <meta name="robots" content="noindex, follow" />
      </head>
      <body style={{ fontFamily: "system-ui, sans-serif", padding: 40, background: "#050505", color: "#F5F4F0" }}>
        <p style={{ fontSize: 13, letterSpacing: "0.2em", textTransform: "uppercase" }}>◇ Redirecting…</p>
        <p style={{ marginTop: 12 }}>
          If you are not redirected, follow this link to the feed:{" "}
          <a href={target} style={{ color: "#0C14E4" }}>
            {target}
          </a>
        </p>
      </body>
    </html>
  );
}
